import { render, staticRenderFns } from "./empty-state-block.vue?vue&type=template&id=0d60bd93"
import script from "./empty-state-block.vue?vue&type=script&lang=js"
export * from "./empty-state-block.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports